"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_plugin_ga_cjs_1 = require("@analytics/google-analytics/lib/analytics-plugin-ga.cjs");
const analytics_cjs_1 = require("analytics/lib/analytics.cjs");
const Config_1 = require("../misc/Config");
const deviceInfo_1 = require("./deviceInfo");
let analytics = null;
function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function getLoadTime() {
    if (window.performance.timing && window.performance.timing.requestStart) {
        return Date.now() - window.performance.timing.requestStart; //safari and older browser
    }
    else {
        return Date.now() - window.performance.timeOrigin; //safari and older browser
    }
}
function InitAnalytics() {
    if (Config_1.ENV.browser !== true)
        return;
    /* Initialize analytics */
    analytics = analytics_cjs_1.default({
        app: 'lobesoft-website',
        version: 100,
        plugins: [
            analytics_plugin_ga_cjs_1.default({
                trackingId: 'UA-145182969-1',
            }),
        ]
    });
    /* Track a page view */
    analytics.page();
    const loadTime = getLoadTime();
    let user = getParameterByName('uid'); // null (absent)
    let origin = getParameterByName('org'); // null (absent)
    if (origin) {
        console.error('origin', origin);
        analyticsTrack('origin', {
            category: 'user',
            label: origin.toString()
        });
        //remove query string
        window.history.replaceState({}, document.title, "/");
    }
    /* store id to track */
    if (user != null) {
        localStorage.setItem('uid', user);
        //remove query string
        window.history.replaceState({}, document.title, "/");
    }
    else
        user = localStorage.getItem('uid');
    if (user == null) {
        /* this user does not have a tracking id generate a new one */
        //@TODO
    }
    /* track user, check query params */
    /* Identify a visitor */
    if (user != null) {
        analytics.identify(user);
        analyticsTrack('userid', {
            category: 'user',
            label: user.toString()
        });
    }
    analyticsTrack('device', {
        category: 'info',
        label: JSON.stringify(deviceInfo_1.detectDevice())
    });
    analyticsTrack('loadTime', {
        category: 'performance',
        label: loadTime.toString(),
        Value: loadTime,
    });
    /* initialize hotjar s*/
    // @ts-ignore
    (function (h, o, t, j, a, r) {
        h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
        h._hjSettings = { hjid: 1594585, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}
exports.InitAnalytics = InitAnalytics;
function analyticsTrack(name, obj) {
    if (Config_1.ENV.browser !== true)
        return;
    /* Track a custom event */
    analytics.track(name, obj);
}
exports.analyticsTrack = analyticsTrack;
function analyticsTrackButton(name, label) {
    if (Config_1.ENV.browser !== true)
        return;
    /* Track a custom event */
    analyticsTrack(name, {
        category: 'button',
        label: label || 'user interacted with a button',
    });
}
exports.analyticsTrackButton = analyticsTrackButton;
function analyticsTrackCTA(name, label) {
    if (Config_1.ENV.browser !== true)
        return;
    /* Track a custom event */
    analyticsTrack(name, {
        category: 'cta',
        label: label || 'user interacted with a cta',
    });
}
exports.analyticsTrackCTA = analyticsTrackCTA;
//# sourceMappingURL=analytics.js.map